import axios from 'axios';
import {
  CaseAttachmentFileRules,
  CaseAttachmentFormModel,
  CaseAttachmentPage,
} from 'app/edozvola/cases/case-attachment/model/case-attachment.model';
import { FileWrapper } from 'app/shared/model/shared.model';

export const fetchCaseAttachments = async ({ signal, pagination, uuid, caseInPreview }): Promise<CaseAttachmentPage> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(
        `api/cases/case-attachments/view/${uuid}?page=${pagination.page}&size=${pagination.size}&column=${pagination.column}&direction=${pagination.direction}&caseInPreview=${caseInPreview}`,
        {
          signal: signal,
        },
      )
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error.error);
      });
  });
};

export const fetchCaseAttachment = async ({ uuid, idCaseAttachment }): Promise<CaseAttachmentFormModel> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/cases/case-attachments/${idCaseAttachment}`)
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error.response.data.detail);
      });
  });
};

export const saveCaseAttachment = async (uuid: string, caseAttachment: CaseAttachmentFormModel): Promise<CaseAttachmentFormModel> => {
  return await new Promise((resolve, reject) => {
    const formData = new FormData();
    formData.append('file', caseAttachment.multipartFile);
    formData.append('dto', new Blob([JSON.stringify(caseAttachment)], { type: 'application/json' })); // Attach JSON as a Blob

    axios
      .post(`api/cases/case-attachments/${uuid}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error.response.data.detail);
      });
  });
};

export const changeCaseAttachmentActivity = async (idCaseAttachment: number): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/cases/case-attachments/${idCaseAttachment}/change-activity`)
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error.response.data.detail);
      });
  });
};

export const deleteCaseAttachment = async (idCaseAttachment): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .delete(`api/cases/case-attachments/${idCaseAttachment}`)
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error.response.data.detail);
      });
  });
};

export const getCaseAttachmentFile = async (idCaseAttachment): Promise<FileWrapper> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/cases/case-attachments/${idCaseAttachment}/preview-file`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const downloadCaseAttachmentFile = async (idCaseAttachment): Promise<FileWrapper> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/cases/case-attachments/${idCaseAttachment}/download-file`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const getCaseAttachmentFileRules = async (idRequestAttachment): Promise<CaseAttachmentFileRules> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/cases/case-attachments/file-rules/${idRequestAttachment}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};
